<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-modal"
      :no-footer="true"
      dialog-width="40rem"
      dialog-height="60vh"
      dialog-min-height="46rem"
    >
      <template #header>
        {{ lss('パーツを追加する', 'Add Component') }}
      </template>
      <div class="jps-modal-content">
        <table class="jps-table">
          <tbody>
          <tr v-for="pp in parts">
            <td>
              <button class="jps-button jps-fullwidth" @click="insert(pp.part)">
                {{ ls(pp.name) }}
              </button>
            </td>
            <td>{{ ls(pp.description) }}</td>
          </tr>
          <tr>
            <td>
              <button
                class="jps-button jps-fullwidth"
                @click="importFromMyNote()"
              >
                {{ lss('マイノート', 'My Note') }}
              </button>
              <ImportFromMyNoteModal ref="importFromMyNoteModal" />
            </td>
            <td>
              {{
                lss(
                  'マイノートの内容を追加します',
                  'Import items from My Note',
                )
              }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import type { BaseModal, ImportFromMyNoteModal } from '#components'

const { ls, lss } = useI18n()
const { getCurationPartsName, getCurationPartsDescription } = useCurationEditor()

interface Props {
  editstate: CurationEditState
}
const props = withDefaults(defineProps<Props>(), {})

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  return await modal.value.openAwait<CurationPartDefinition[]>()
}
defineExpose({ openAwait })

const parts = computed(() => {
  return PART_PALLET.filter(p => {
    if (p.type === 'jps-curation-subpage-list') {
      if (props.editstate.page === 'gallery') return true
      return false
    }
    return true
  }).map(p => {
    return {
      name: getCurationPartsName(p),
      description: getCurationPartsDescription(p),
      part: p,
    }
  })
})

const insert = (p: CurationPartDefinition) => {
  let part = clone(p)
  part.cpid = hashId()
  modal.value.resolve([part])
}

const importFromMyNoteModal = ref<InstanceType<typeof ImportFromMyNoteModal>>()
const importFromMyNote = async () => {
  try {
    let parts = await importFromMyNoteModal.value.openAwait()
    parts = clone(parts)
    forEachParts(parts, p => {
      p.cpid = luId()
    })
    modal.value.resolve(parts)
  } catch (cancel) {}
}
</script>
